export default {
      id: "i-service-stock-min-usage",
      viewBox: "0 0 70 70",
      url: __webpack_public_path__ + "img/sprite.svg#i-service-stock-min",
      toString: function () {
        return this.url;
      }
    }